import { Component } from './component';
import { FieldRow } from './field-row';
import { Label } from './label';
import { OptionButton } from './option-button';

export type OptionButtonOptions =
  | string
  | { label?: string; value?: string; disabled?: boolean };

export interface OptionButtonGroupProps {
  name: string;
  options: OptionButtonOptions[];
  value?: string;
  onSelect?: (value: string) => void;
}

export class OptionButtonGroup extends Component {
  public el: HTMLDivElement;

  constructor(props: OptionButtonGroupProps) {
    super();
    this.el = document.createElement('div');
    this.el.classList.add('option-button-group');

    if (props.options.length === 0) {
      throw new Error('OptionButtonGroup must have at least one option');
    }

    for (const [index, option] of props.options.entries()) {
      const opt =
        typeof option === 'string' ? { label: option, value: option } : option;

      if (!opt.value && !opt.label) {
        throw new Error('Option must have at least a label or a value');
      }

      const row = new FieldRow();
      const optionButton = new OptionButton({
        name: props.name,
        value: opt.value ?? opt.label ?? `option-${index}`,
        ...opt,
      });

      if (opt.label) {
        optionButton.el.id = `option-button-${props.name}-${index}`;
      }

      row.el.appendChild(optionButton.el);

      if (opt.label) {
        const label = new Label({
          text: opt.label,
          for: `option-button-${props.name}-${index}`,
        });
        row.el.appendChild(label.el);
      }

      this.el.appendChild(row.el);

      if (props.value && props.value === optionButton.el.value) {
        optionButton.setValue(true);
      }

      optionButton.el.addEventListener('change', () => {
        if (optionButton.getValue() && props.onSelect) {
          props.onSelect(optionButton.el.value);
        }
      });
    }
  }
}
